import { featuredBoards } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function FeaturedBoards() {
  const [main, ...rest] = featuredBoards;
  return (
    <section id="feature" className="scroll-mt-24 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <SectionHead
          kicker="stack-line"
          title="专题精选 · 一次看全"
          sub="围绕热点事件的多视角合辑，封面即入口，点开直达完整专题页。"
        />

        {/* Main wide feature */}
        <a
          href="#feed"
          className="group relative block h-[320px] overflow-hidden rounded-xl md:h-[400px]"
        >
          <img
            src={main.cover}
            alt={main.title}
            title={main.title}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10" />
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
            <div className="mb-3 flex flex-wrap items-center gap-2">
              <span className="rounded bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
                {main.tag}
              </span>
              <span className="text-xs text-white/80">{main.parts} 期连载 · {main.reads} 阅读</span>
            </div>
            <h3 className="max-w-3xl font-heading text-xl font-bold text-white md:text-3xl">{main.title}</h3>
            <p className="mt-2 max-w-2xl text-sm text-white/80 md:text-base">{main.excerpt}</p>
          </div>
        </a>

        {/* Rest grid */}
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {rest.map((b) => (
            <a
              key={b.title}
              href="#feed"
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-background-300"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={b.cover}
                  alt={b.title}
                  title={b.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded bg-black/60 px-2 py-0.5 text-[11px] text-white">
                  {b.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h4 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-950">
                  {b.title}
                </h4>
                <div className="mt-2 flex items-center gap-2 text-[11px] text-foreground-400">
                  <span>{b.parts} 期连载</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true" />
                    {b.reads}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}